import React from "react"
import { AutocompleteAjaxSeeker } from "@ui-seeker/core"
import { BACKEND_APIS } from "@constants"


export default function AppCurrencyAutocomplete({ ...props }) {
    return <AutocompleteAjaxSeeker
		filterSelectedOptions={false} 
		label="Currency"
		placeholder="Select currency"
		urlAjax={`${BACKEND_APIS.MASTER_DATA}/all/options/currencies`}
		{...props}
	/>
}